import React, { useEffect, useRef, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DwDropDown = ({options, label, value, onChange}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value);
    const selectRef = useRef(null);

    const handleOptionClick = (e, value) => {
        e.stopPropagation();
        setSelectedValue(value);
        setShowDropdown(false);
        if (onChange) {
            onChange(value);
        }
    };

    const handleShowDropdown = () => {
        setShowDropdown(prev => !prev);
    };

    const handleOutsideClick = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    return (
        <div ref={selectRef} class="dw-select-wrapper">
            <div class={`dw-select ${showDropdown && 'showDropdown'} ${selectedValue !== 'select' && 'dw-active'}`}>
                <div class='dw-select-trigger' onClick={() => {handleShowDropdown()}}>
                    <div className='dw-select-label-container'>
                        {

                            !showDropdown ?
                            <>
                                <div className='label'>
                                    {label}
                                </div>
                                <div className='value'>
                                    {options.find((item) => item.value === selectedValue)?.label || 'Select'}
                                </div>
                            </>
                            :
                            <div className='label'>Select {label}</div>
                        }
                    </div>

                    {
                        !showDropdown ?
                            <i className='icon-updown-ico'></i>
                            :
                            <i className='icon-cross-ico' onClick={() => setShowDropdown(false)}></i>
                    }
                </div>
                {
                    showDropdown && 
                    <div class="dw-options">
                        {
                            options.map((item, index) => 
                                <OverlayTrigger
                                    key={index}
                                    placement={'top'}
                                    overlay={
                                        <Tooltip id={`tooltip-top`}>
                                            {item.label}
                                        </Tooltip>
                                    }
                                >
                                    <div key={index} class={`dw-option ${item.value === selectedValue && 'dw-selected'}`} value={item.value} onClick={(e) => {handleOptionClick(e, item.value)}}>{item.label}</div>                                       
                                </OverlayTrigger>
                            )
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default DwDropDown